import { Button, Container, Segment } from "semantic-ui-react";
import { IRecipientModel } from "../../../../Models/Recipient";
import { observer } from "mobx-react-lite";
import MedicalScoreCard from "../Medical/MedicalScoreCard";
import LegalScoreCard from "../Legal/LegalScoreCard";
import FamilyScoreCard from "../Family/FamilyScoreCard";
import SpiritualScoreCard from "../Spiritual/SpiritualScoreCard";
import styles from './Score.style.module.css';

export interface IScoreMemberContainerProps {
  selectedRecipient: IRecipientModel;
  caregiverId: string;
}

const ScoreContainer: React.FC<IScoreMemberContainerProps> = ({
  selectedRecipient, caregiverId
}) => {
  const canViewAllTasks =
    selectedRecipient.medicalScoreComplete === 100 &&
    selectedRecipient.familyScoreComplete === 100 &&
    selectedRecipient.legalScoreComplete === 100 &&
    selectedRecipient.spiritualScoreComplete === 100;

  return (
    <>
      <div style={{ padding: '1em', marginTop: 20 }} className={styles['all-columns']}>
        <MedicalScoreCard selectedRecipient={selectedRecipient} caregiverId={caregiverId} />
        <LegalScoreCard selectedRecipient={selectedRecipient} caregiverId={caregiverId} />
        <FamilyScoreCard selectedRecipient={selectedRecipient} caregiverId={caregiverId} />
        <SpiritualScoreCard selectedRecipient={selectedRecipient} caregiverId={caregiverId} />
        <Container>
          <Segment basic textAlign="center">
            {canViewAllTasks && <Button>View all Tasks</Button>}
          </Segment>
        </Container>
      </div>
    </>
  );
};

export default observer(ScoreContainer);
